import React, { createContext, useContext, useState } from 'react';

const AppContext = createContext();

export function AppProvider({ children }) {
  const [currentView, setCurrentView] = useState('customer'); // 'customer', 'admin', 'partner'
  const [activeTab, setActiveTab] = useState('home');
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const [notifications, setNotifications] = useState([]);

  const addNotification = (notification) => {
    const id = Date.now();
    setNotifications((prev) => [...prev, { ...notification, id }]);
    setTimeout(() => {
      setNotifications((prev) => prev.filter((n) => n.id !== id));
    }, 3000);
  };

  const value = {
    currentView,
    setCurrentView,
    activeTab,
    setActiveTab,
    selectedOffer,
    setSelectedOffer,
    selectedVoucher,
    setSelectedVoucher,
    notifications,
    addNotification,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
}
